/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppPeopleRouteImport } from './routes/_app/people'
import { Route as AppSavedRouteImport } from './routes/_app/saved'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppThreadsRouteImport } from './routes/_app/threads'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as ResetTokenRouteImport } from './routes/reset.$token'
import { Route as AppCSlugRouteImport } from './routes/_app/c.$slug'
import { Route as AppDmIdRouteImport } from './routes/_app/dm.$id'
import { Route as AppSettingsAuditRouteImport } from './routes/_app/settings.audit'
import { Route as AppSettingsEmojiRouteImport } from './routes/_app/settings.emoji'
import { Route as AppSettingsInvitesRouteImport } from './routes/_app/settings.invites'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings.notifications'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings.profile'
import { Route as AppSettingsSessionsRouteImport } from './routes/_app/settings.sessions'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings.users'
import { Route as AppSettingsWorkspaceRouteImport } from './routes/_app/settings.workspace'
import { Route as AppCSlugMessageIdRouteImport } from './routes/_app/c.$slug_.$messageId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleRoute = AppPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AppRoute,
} as any)
const AppSavedRoute = AppSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppThreadsRoute = AppThreadsRouteImport.update({
  id: '/threads',
  path: '/threads',
  getParentRoute: () => AppRoute,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetTokenRoute = ResetTokenRouteImport.update({
  id: '/reset/$token',
  path: '/reset/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCSlugRoute = AppCSlugRouteImport.update({
  id: '/c/$slug',
  path: '/c/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppDmIdRoute = AppDmIdRouteImport.update({
  id: '/dm/$id',
  path: '/dm/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAuditRoute = AppSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsEmojiRoute = AppSettingsEmojiRouteImport.update({
  id: '/emoji',
  path: '/emoji',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsInvitesRoute = AppSettingsInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSessionsRoute = AppSettingsSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsWorkspaceRoute = AppSettingsWorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppCSlugMessageIdRoute = AppCSlugMessageIdRouteImport.update({
  id: '/c/$slug_/$messageId',
  path: '/c/$slug/$messageId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/people': typeof AppPeopleRoute
  '/saved': typeof AppSavedRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/threads': typeof AppThreadsRoute
  '/join/$token': typeof JoinTokenRoute
  '/reset/$token': typeof ResetTokenRoute
  '/c/$slug': typeof AppCSlugRoute
  '/dm/$id': typeof AppDmIdRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/emoji': typeof AppSettingsEmojiRoute
  '/settings/invites': typeof AppSettingsInvitesRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/sessions': typeof AppSettingsSessionsRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/c/$slug/$messageId': typeof AppCSlugMessageIdRoute
}
export interface FileRoutesByTo {
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/people': typeof AppPeopleRoute
  '/saved': typeof AppSavedRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/threads': typeof AppThreadsRoute
  '/join/$token': typeof JoinTokenRoute
  '/reset/$token': typeof ResetTokenRoute
  '/': typeof AppIndexRoute
  '/c/$slug': typeof AppCSlugRoute
  '/dm/$id': typeof AppDmIdRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/emoji': typeof AppSettingsEmojiRoute
  '/settings/invites': typeof AppSettingsInvitesRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/sessions': typeof AppSettingsSessionsRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/c/$slug/$messageId': typeof AppCSlugMessageIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot': typeof ForgotRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/_app/people': typeof AppPeopleRoute
  '/_app/saved': typeof AppSavedRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/threads': typeof AppThreadsRoute
  '/join/$token': typeof JoinTokenRoute
  '/reset/$token': typeof ResetTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/c/$slug': typeof AppCSlugRoute
  '/_app/dm/$id': typeof AppDmIdRoute
  '/_app/settings/audit': typeof AppSettingsAuditRoute
  '/_app/settings/emoji': typeof AppSettingsEmojiRoute
  '/_app/settings/invites': typeof AppSettingsInvitesRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/sessions': typeof AppSettingsSessionsRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/_app/c/$slug_/$messageId': typeof AppCSlugMessageIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot'
    | '/login'
    | '/setup'
    | '/people'
    | '/saved'
    | '/search'
    | '/settings'
    | '/threads'
    | '/join/$token'
    | '/reset/$token'
    | '/c/$slug'
    | '/dm/$id'
    | '/settings/audit'
    | '/settings/emoji'
    | '/settings/invites'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/sessions'
    | '/settings/users'
    | '/settings/workspace'
    | '/c/$slug/$messageId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot'
    | '/login'
    | '/setup'
    | '/people'
    | '/saved'
    | '/search'
    | '/settings'
    | '/threads'
    | '/join/$token'
    | '/reset/$token'
    | '/'
    | '/c/$slug'
    | '/dm/$id'
    | '/settings/audit'
    | '/settings/emoji'
    | '/settings/invites'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/sessions'
    | '/settings/users'
    | '/settings/workspace'
    | '/c/$slug/$messageId'
  id:
    | '__root__'
    | '/_app'
    | '/forgot'
    | '/login'
    | '/setup'
    | '/_app/people'
    | '/_app/saved'
    | '/_app/search'
    | '/_app/settings'
    | '/_app/threads'
    | '/join/$token'
    | '/reset/$token'
    | '/_app/'
    | '/_app/c/$slug'
    | '/_app/dm/$id'
    | '/_app/settings/audit'
    | '/_app/settings/emoji'
    | '/_app/settings/invites'
    | '/_app/settings/notifications'
    | '/_app/settings/profile'
    | '/_app/settings/sessions'
    | '/_app/settings/users'
    | '/_app/settings/workspace'
    | '/_app/c/$slug_/$messageId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotRoute: typeof ForgotRoute
  LoginRoute: typeof LoginRoute
  SetupRoute: typeof SetupRoute
  JoinTokenRoute: typeof JoinTokenRoute
  ResetTokenRoute: typeof ResetTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people': {
      id: '/_app/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof AppPeopleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/saved': {
      id: '/_app/saved'
      path: '/saved'
      fullPath: '/saved'
      preLoaderRoute: typeof AppSavedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/threads': {
      id: '/_app/threads'
      path: '/threads'
      fullPath: '/threads'
      preLoaderRoute: typeof AppThreadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset/$token': {
      id: '/reset/$token'
      path: '/reset/$token'
      fullPath: '/reset/$token'
      preLoaderRoute: typeof ResetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/c/$slug': {
      id: '/_app/c/$slug'
      path: '/c/$slug'
      fullPath: '/c/$slug'
      preLoaderRoute: typeof AppCSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dm/$id': {
      id: '/_app/dm/$id'
      path: '/dm/$id'
      fullPath: '/dm/$id'
      preLoaderRoute: typeof AppDmIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/audit': {
      id: '/_app/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof AppSettingsAuditRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/emoji': {
      id: '/_app/settings/emoji'
      path: '/emoji'
      fullPath: '/settings/emoji'
      preLoaderRoute: typeof AppSettingsEmojiRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/invites': {
      id: '/_app/settings/invites'
      path: '/invites'
      fullPath: '/settings/invites'
      preLoaderRoute: typeof AppSettingsInvitesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/sessions': {
      id: '/_app/settings/sessions'
      path: '/sessions'
      fullPath: '/settings/sessions'
      preLoaderRoute: typeof AppSettingsSessionsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/workspace': {
      id: '/_app/settings/workspace'
      path: '/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AppSettingsWorkspaceRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/c/$slug_/$messageId': {
      id: '/_app/c/$slug_/$messageId'
      path: '/c/$slug/$messageId'
      fullPath: '/c/$slug/$messageId'
      preLoaderRoute: typeof AppCSlugMessageIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsAuditRoute: typeof AppSettingsAuditRoute
  AppSettingsEmojiRoute: typeof AppSettingsEmojiRoute
  AppSettingsInvitesRoute: typeof AppSettingsInvitesRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsSessionsRoute: typeof AppSettingsSessionsRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppSettingsWorkspaceRoute: typeof AppSettingsWorkspaceRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAuditRoute: AppSettingsAuditRoute,
  AppSettingsEmojiRoute: AppSettingsEmojiRoute,
  AppSettingsInvitesRoute: AppSettingsInvitesRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSessionsRoute: AppSettingsSessionsRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppSettingsWorkspaceRoute: AppSettingsWorkspaceRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppPeopleRoute: typeof AppPeopleRoute
  AppSavedRoute: typeof AppSavedRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppThreadsRoute: typeof AppThreadsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCSlugRoute: typeof AppCSlugRoute
  AppDmIdRoute: typeof AppDmIdRoute
  AppCSlugMessageIdRoute: typeof AppCSlugMessageIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppPeopleRoute: AppPeopleRoute,
  AppSavedRoute: AppSavedRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppThreadsRoute: AppThreadsRoute,
  AppIndexRoute: AppIndexRoute,
  AppCSlugRoute: AppCSlugRoute,
  AppDmIdRoute: AppDmIdRoute,
  AppCSlugMessageIdRoute: AppCSlugMessageIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotRoute: ForgotRoute,
  LoginRoute: LoginRoute,
  SetupRoute: SetupRoute,
  JoinTokenRoute: JoinTokenRoute,
  ResetTokenRoute: ResetTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
